.stats-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: start;
  z-index: 300;
}

.stats-modal {
  border-radius: 12px;
  margin: 10px;
  max-width: 90%;
  min-width: 30%;
  /* max-height: 100vh; */
  min-height: 30%;
  max-height: 95%;
  overflow-y: auto;
}

.stats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid var(--vp-controls-bg);
}

.stats-header h3 {
  margin: 0;
  color: var(--vp-text);
  font-size: 18px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--vp-text);
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stats-content {
  padding: 2px 10px;
}

/* Styles for the stats notification */
.stats-notification-container {
  position: absolute;
  top: 16px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 4px;
}

.stats-info-icon {
  width: 24px;
  height: 24px;
  background-color: var(--vp-controls-bg);
  color: var(--vp-video-text);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  border: 2px solid var(--vp-video-text);
}

.stats-info-icon:hover {
  transform: scale(1.1);
}

.stats-alert-strip {
  position: absolute;
  white-space: nowrap;
  background-color: var(--vp-controls-bg);
  color: var(--vp-video-text);
  padding: 6px 16px;
  border-radius: 4px;
  animation: slideIn 0.5s forwards, fadeOut 0.5s 6s forwards;
  transform: translateX(100%);
  opacity: 0;
  cursor: pointer;
}

@media (max-width: 768px) {
  .stats-modal {
    width: 95%;
    margin: 20px;
  }

  .stats-content {
    padding: 15px;
  }
}